import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface Cidade {
  nome: string;
  codigo_ibge?: string;
}

export interface Estado {
  nome: string;
  sigla: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private readonly baseUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades';
  
  private estados: Estado[] = [
    { nome: 'Acre', sigla: 'AC' },
    { nome: 'Alagoas', sigla: 'AL' },
    { nome: 'Amapá', sigla: 'AP' },
    { nome: 'Amazonas', sigla: 'AM' },
    { nome: 'Bahia', sigla: 'BA' },
    { nome: 'Ceará', sigla: 'CE' },
    { nome: 'Distrito Federal', sigla: 'DF' },
    { nome: 'Espírito Santo', sigla: 'ES' },
    { nome: 'Goiás', sigla: 'GO' },
    { nome: 'Maranhão', sigla: 'MA' },
    { nome: 'Mato Grosso', sigla: 'MT' },
    { nome: 'Mato Grosso do Sul', sigla: 'MS' },
    { nome: 'Minas Gerais', sigla: 'MG' },
    { nome: 'Pará', sigla: 'PA' },
    { nome: 'Paraíba', sigla: 'PB' },
    { nome: 'Paraná', sigla: 'PR' },
    { nome: 'Pernambuco', sigla: 'PE' },
    { nome: 'Piauí', sigla: 'PI' },
    { nome: 'Rio de Janeiro', sigla: 'RJ' },
    { nome: 'Rio Grande do Norte', sigla: 'RN' },
    { nome: 'Rio Grande do Sul', sigla: 'RS' },
    { nome: 'Rondônia', sigla: 'RO' },
    { nome: 'Roraima', sigla: 'RR' },
    { nome: 'Santa Catarina', sigla: 'SC' },
    { nome: 'São Paulo', sigla: 'SP' },
    { nome: 'Sergipe', sigla: 'SE' },
    { nome: 'Tocantins', sigla: 'TO' }
  ];

  constructor(private http: HttpClient) {}

  /**
   * Obtém a lista de cidades de um estado
   * @param uf Sigla do estado (UF)
   * @returns Observable com a lista de cidades
   */
  getCidadesByUF(uf: string): Observable<Cidade[]> {
    if (!uf) {
      return of([]);
    }

    return this.http.get<any[]>(`${this.baseUrl}/estados/${uf}/municipios`).pipe(
      map(response => {
        return response.map(cidade => ({
          nome: cidade.nome,
          codigo_ibge: cidade.id.toString()
        }));
      }),
      catchError(error => {
        console.error('Erro ao buscar cidades:', error);
        return of([]);
      })
    );
  }

  /**
   * Obtém a lista completa de estados
   */
  getEstados(): Estado[] {
    return this.estados;
  }

  /**
   * Busca informações de um estado pela sigla
   * @param sigla Sigla do estado (UF)
   * @returns Objeto com informações do estado ou undefined se não encontrado
   */
  getEstadoBySigla(sigla: string): Estado | undefined {
    return this.estados.find(estado => estado.sigla === sigla);
  }
}
